//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  useState,
  useContext,
  useCallback,
  useEffect,
  Fragment,
} from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import * as moment from 'moment';

// custom pages
import dashboard from 'apis/dashboard/dashboard';
import 'antd/dist/antd.css';

import Context from 'context/context';
import { sidebarStyles } from './style';
import access from 'config/access';

// material-ui
import Tooltip from '@material-ui/core/Tooltip';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
// material-ui icons
import CancelIcon from '@material-ui/icons/Cancel';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { withStyles } from '@material-ui/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useTranslation } from 'react-i18next';
import { imageHandler } from 'helpers/imageHandler';
import { dateFormat, pointsFormat } from "helpers/dataFormat";
// import LockOpenIcon from '@material-ui/icons-material/LockOpen';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InfoIcon from '@material-ui/icons/Info';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';


//Analytics
import { logEvent } from 'helpers/analytics';
import { useTrackWithGTM } from 'helpers/gtm';




const GlobalCss = withStyles({
  '@global': {
    '.MuiListItem-gutters': {
      paddingLeft: '10px !important',
    },
  },
})(() => null);

const GreenTooltip = withStyles({
  tooltip: {
    color: "green",
    backgroundColor: "white"
  }
})(Tooltip);

const RedTooltip = withStyles({
  tooltip: {
    color: "red",
    backgroundColor: "white"
  }
})(Tooltip);
const BlueTooltip = withStyles({
  tooltip: {
    color: "white",
    backgroundColor: "black",
    maxWidth: 250,
  }
})(Tooltip);

export default function SideBar(props) {
  const { state, dispatch } = useContext(Context);
  const { getTier, getBillingAccount,getPoints } = dashboard();
  const [dialog, setDialog] = useState(false);
  const [isAdminOption, setIsAdminOption] = useState(false);
  const [isITAdminOption, setIsITAdminOption] = useState(false);

  const [tierName, setTierName] = useState('');
  const [pointsAlter, setPointsAlter] = useState({});

  const classes = sidebarStyles();
  const routes = props.routes;
  const history = useHistory();
  const { trackWithGTM } = useTrackWithGTM();

  //Translation
  const { t, i18n } = useTranslation();

  const [states, setstates] = useState({
    loyalityAccount: {},
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const toggleAdminOption = () => {
    setIsAdminOption(!isAdminOption);
  };
  const toggleAdminOptionIT = () => {
    setIsITAdminOption(!isITAdminOption);
  };

  // handling api calls
  useEffect(() => {

    if (state.ALA && Object.keys(state.ALA).length > 0) {
      handleGetBillingAccount();
      handleGetPoints();
      return;
    }
  }, [state.ALA]);

  // Billing Account api func
  const handleGetBillingAccount = async () => {
    try {
      let values = state.ALA.loyalty_id;
      let res = await getBillingAccount(values);
      if (res) {
        dispatch({ type: 'SET_BILLINGACCOUNT', payload: res?.data });
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };
  const handleGetPoints = async () => {
    dispatch({ type: 'SET_LOADING', payload: true });
    try {
      let values = state.ALA.loyalty_id;
      let res = await getPoints(values);
      if (res) {
        setPointsAlter(res)
        dispatch({ type: 'SET_LOADING', payload: false });
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // redirection func
  const redirectLink = (link, redirect) => {
    if (redirect) {
      return;
    }
    return link;
  };

  console.log(routes,"routes")

  // specified routes
  const routes1 = routes.filter((item) => !item.isAdmin && !item.isITAdmin);
  const isCanada = state.userInfo?.loyalty_organization_name === "Henry Schein Canada";
  const isUS     = state.userInfo?.loyalty_organization_name === "Henry Schein Dental";
  
  // ADMIN ROUTES
  const routes2 = routes.filter(item => {
    
    // Canada → Tier Range only in Admin
    if (item.name === "Tier Range" && isCanada) {
      return true;  // include in Admin
    }
    
    // US → Tier Range NOT in Admin
    if (item.name === "Tier Range" && isUS) {
      return false; // exclude from Admin
    }
  
    return item.isAdmin && !item.isITAdmin;
  });
  
  // IT ADMIN ROUTES
  const routes3 = routes.filter(item => {
  
    // US → Tier Range only in IT Admin
    if (item.name === "Tier Range" && isUS) {
      return true;  // include in IT Admin
    }
  
    // Canada → Tier Range NOT in IT Admin
    if (item.name === "Tier Range" && isCanada) {
      return false; // exclude from IT Admin
    }
  
    return item.isITAdmin;
  });
  // const routes2 = routes.filter((item) => item.isAdmin && !item.isITAdmin);
  // const routes3 = routes.filter((item) => item.isITAdmin);


  const tier = state?.ALA?.['Loyalty_Account.tier'];
  const org = state?.userInfo?.loyalty_organization_name;

  // Check whether end date is today or within next 30 days
  const isEndDateWithin30Days = (endDate) => {
    if (!endDate) return false;

    const end = moment(endDate);

    if (!end.isValid()) return false;

    const today = moment().startOf('day');
    const maxDate = moment().add(30, 'days').endOf('day');

    return (
      end.isSameOrAfter(today) &&
      end.isSameOrBefore(maxDate)
    );
  };

  // Handle boolean / numeric / string flag values from API
  const isFlagEnabled = (value) => {
    return (
      value === true ||
      value === 1 ||
      value === '1' ||
      value === 'true'
    );
  };

  const signatureEndDate = state?.ACA?.signature_end_date;
  const unlockedEndDate = state?.ACA?.unlocked_end_date;
  const startupEndDate = state?.ACA?.startup_end_date;

  const privilegeCode = String(state?.ACA?.privilege_code || '').toUpperCase();

  const signatureFlag = isFlagEnabled(state?.ACA?.signature_flag);
  const unlockedFlag = isFlagEnabled(state?.ACA?.unlocked_flag);
  const startupFlag = isFlagEnabled(state?.ACA?.startup_flag);

  const isUnlockedCustomer = signatureFlag && unlockedFlag;

  const isStartupCustomer = startupFlag && !signatureFlag && !unlockedFlag;

  const isSignatureTrial = privilegeCode === 'ST2' && signatureFlag && !unlockedFlag;

  const isSignatureMonthly = privilegeCode === 'ST0' && signatureFlag && !unlockedFlag;

  const isSignatureYearly = privilegeCode === 'ST1' && signatureFlag && !unlockedFlag;

  // =====================================================
  // END DATE
  // =====================================================

  // Monthly / Yearly → use signature_end_date
  const effectiveSignatureEndDate = isUnlockedCustomer ? unlockedEndDate : signatureEndDate;

  const showSignatureEndDate = (isSignatureMonthly || isSignatureYearly || isUnlockedCustomer) &&
    isEndDateWithin30Days(effectiveSignatureEndDate);


  // Trial
  const showTrialEndDate = isSignatureTrial && isEndDateWithin30Days(signatureEndDate);

  // Startup
  const showStartupEndDate = isStartupCustomer && isEndDateWithin30Days(startupEndDate);
  // check current route
  function isThisRoute(sidebar) {
    if (sidebar) {
      if (
        sidebar.to.toLowerCase() === window.location.pathname.toLowerCase() ||
        sidebar.childRoutes.includes(window.location.pathname.toLowerCase())
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      let isCurrentPath = false;
      routes2.forEach((item) => {
        if (
          item.to.toLowerCase() === window.location.pathname.toLowerCase() ||
          item.childRoutes.includes(window.location.pathname.toLowerCase())
        ) {
          isCurrentPath = true;
        }
      });
      return isCurrentPath;
    }
  }

  console.log(imageHandler?.[org]?.[i18n?.language],"imageHandler?.[org]?.[i18n?.language]")
  


  return (
    <React.Fragment>
      <GlobalCss />
      <div className={classes.sidebarHeaderForMobile}>
        <div className={classes.customerName}>
          {state.billingAccount?.customer_name?.toUpperCase()}
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div>
            {state.ALA && Object.keys(state.ALA).length > 0 && (
              <div>
                <img
                  src={state?.ACA?.signature_flag ? imageHandler?.[org]?.[i18n?.language]?.[`SignatureSidebarLogo`] : imageHandler?.[org]?.[i18n?.language]?.[`${tier}SidebarLogo`]}

                  width='100%'
                  className={classes.tierImg}
                />
              </div>
            )}
          </div>
          <div className={classes.sidebarHeaderTxt}>
            <div style={{ whiteSpace: 'nowrap', fontSise: 14 }}>
              {t('Member ID')}: {state?.ALA?.loyalty_id}
            </div>
            <div
              style={{
                whiteSpace: 'nowrap',
                fontSise: 12,
                marginBottom: 5,
                opacity: 0.7,
              }}
            >
              {state?.ALA?.['Loyalty_Account.created_at'] && (
                <span>
                  {t('Member Since')}:{' '}
                  {dateFormat(state?.ALA?.['Loyalty_Account.signup_date'], i18n?.language)}
                </span>
              )}
            </div>
            {state.userInfo.isCdrAdmin && (
              <div
                onClick={() => history.push('/dashboard/loyalty')}
                className={classes.changeLoyaltyBtn}
              >
                {t('Change Account')}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={classes.component}>
        <div className={state?.ACA?.unlocked_flag ? classes.sidebarHeaderUnlock :classes.sidebarHeader}>
        <div
  className={
    state?.ACA?.unlocked_flag
      ? classes.customerNameUnlock
      : classes.customerName
  }
  // style={{ display: "flex", alignItems: "center", gap: "2px" }}
>

  <span style={{ fontSize: "16px",  
    flex: 1,
    whiteSpace: 'nowrap',    // Note the capital 'S'
    overflow: 'hidden',
    textOverflow: 'ellipsis'}}>
  {state.billingAccount?.customer_name?.toUpperCase()}
  </span>

  {state?.ACA?.unlocked_flag && (
  <div style={{ display: "flex", alignItems: "center", gap: "5px",marginTop:"5px" }}>
    {/* Gray background only for text + lock */}
    <span
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#e0e0e0",
        padding: "5px 10px",
        borderRadius: "15px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      <span
        style={{
          fontSize: "10px",
          fontWeight: "bold",
          marginRight: "4px",
        }}
      >
        Thrive Unlocked
      </span>

      <LockOpenIcon
        style={{
          fontSize: 15,
          color: "black",
          transform: "scaleX(-1)",
        }}
      />
    </span>

    {/* Tooltip on info icon */}
    <BlueTooltip
      title={t(
        "Thrive Unlocked provides access to available Thrive Signature benefits, plus opportunities to earn Thrive Rewards Growth Bonus Points."
      )}
      placement="bottom"
      arrow
    >
      <InfoIcon
        style={{
          fontSize: 15,
          color: "#0A72BA",
          cursor: "pointer",
        }}
      />
    </BlueTooltip>
  </div>
)}

</div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginLeft: state?.userInfo?.loyalty_organization_name === "Henry Schein Canada" ? "11px" : "0px",
            }}
          >

            


            <div>
            {state.ALA && Object.keys(state.ALA).length > 0 && (
                <div>
                  <img 
                   src={
                    state?.ACA?.startup_flag
                      ? imageHandler?.[org]?.[i18n?.language]?.[`Startuplogo`]
                      : state?.ACA?.signature_flag
                      ? imageHandler?.[org]?.[i18n?.language]?.[`Newsignaturelogo`]
                      : state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental'
                      ? imageHandler?.[org]?.[i18n?.language]?.[`${tier}SidebarLogoNew`]
                      : imageHandler?.[org]?.[i18n?.language]?.[`${tier}SidebarLogo`]
                  }
                    height="auto"
                    // width={state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' ? 75 : 80}
                    width={
                      state?.userInfo?.loyalty_organization_name === "Henry Schein Dental"
                        ? state?.ACA?.startup_flag
                          ? 110
                          : state?.ACA?.signature_flag ?100:75
                        : i18n.language == "en"?110:100
                    }
                    className={
                      state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" &&
                      !state?.ACA?.startup_flag
                        ?  classes.tierImgnew 
                        : classes.tierImg
                    }
                  />
                </div>
              )}

            </div>
            <div className={state?.ACA?.unlocked_flag ? classes.sidebarHeaderTxtUnlock:classes.sidebarHeaderTxt}>
              <div style={{ whiteSpace: 'nowrap' }}>
                {t('Member ID')}: {state.ALA && state.ALA?.loyalty_id}{' '}
                <span style={{ verticalAlign: 'middle' }}>
                  {' '}
                  {state.ALA &&
                    Object.keys(state.ALA).length > 0 &&
                    (state?.ALA?.['Loyalty_Account.consent_flag'] ? (
                      <GreenTooltip title={t('Consented')} placement="top" arrow>
                        
                        <CheckCircleIcon style={{ fontSize: 17, color: 'green',  background: 'radial-gradient(circle, white 55%, transparent 55%)' }} />

                        
                      </GreenTooltip>
                    ) : (
                      <RedTooltip title={t('Un Consented')} placement="top" arrow>
                        <CancelIcon style={{ fontSize: 14, color: 'red' }} />
                      </RedTooltip>
                    ))}
                </span>
              </div>
              {state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental' && state?.ACA?.customer_account_number && <div>
                {t('Ship To ID')}: {state.ACA && state.ACA?.customer_account_number}
              </div>}
              <div
                style={{
                  whiteSpace: 'nowrap',
                  marginBottom: 5,
                  opacity: state?.ACA?.unlocked_flag ? 1: 0.7,
                }}
              >
                {state?.ALA?.['Loyalty_Account.created_at'] && (
                  <span style={{fontWeight:"bold"}}>
                    {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && (state?.ACA?.signature_flag ||state?.ACA?.startup_flag )) ? t('Rewards Since') : t('Member Since')}:{' '}
                    {dateFormat(state.ACA && state.ACA?.['Loyalty_Account.signup_date'] ? state.ACA?.['Loyalty_Account.signup_date'] : state.ALA?.['Loyalty_Account.signup_date'], i18n?.language)}
                  </span>
                )}
                <br />

                {(state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental' && state?.ALA?.['Loyalty_Account.created_at'] && state?.ACA?.signature_flag && state?.ACA?.signature_start_date) && (
                  <span>
                    {t('Signature Since')}:{' '}
                    {dateFormat(state?.ACA?.signature_start_date, i18n?.language)}
                  </span>
                )}
                {(state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental' && state?.ALA?.['Loyalty_Account.created_at'] && state?.ACA?.signature_flag && state?.ACA?.signature_start_date) && (
                  <br />
                )}
                {/* Signature Ends Monthly / Yearly / Unlocked */}
                {showSignatureEndDate && (
                  <>
                    <span className={classes.signatureend}>
                      {t('Signature Ends')}:{' '}
                      {dateFormat(
                        effectiveSignatureEndDate,
                        i18n?.language
                      )}
                    </span>
                    <br />
                  </>
                )}

                {/* Trial Ends ST2 Signature Trial only*/}
                {showTrialEndDate && (
                  <>
                    <span className={classes.signatureend}>
                      {t('Trial Ends')}:{' '}
                      {dateFormat(
                        signatureEndDate,
                        i18n?.language
                      )}
                    </span>
                    <br />
                  </>
                )}


                {(state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental' && state?.ALA?.['Loyalty_Account.created_at'] && state?.ACA?.startup_flag && state?.ACA?.startup_start_date) && (
                  <span>
                    {t('Startup Since')}:{' '}
                    {dateFormat(state?.ACA?.startup_start_date, i18n?.language)}
                  </span>
                )}
                {(state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental' && state?.ALA?.['Loyalty_Account.created_at'] && state?.ACA?.startup_flag && state?.ACA?.startup_start_date) && (
                  <br />
                )}

                {/* Startup Ends ST3 Startup only */}
                {showStartupEndDate && (
                  <>
                    <span className={classes.signatureend}>
                      {t('Startup Ends')}:{' '}
                      {dateFormat(
                        startupEndDate,
                        i18n?.language
                      )}
                    </span>
                    <br />
                  </>
                )}

                {(state?.userInfo?.loyalty_organization_name !== 'Henry Schein Dental' && access['sidebar']['changeLoyalty'][state.userInfo.role]) &&
                  state?.ALA?.['Loyalty_Account.is_active'] != null && (
                    <span>
                      {t('Account Status')}:{' '}
                      {state?.ALA?.['Loyalty_Account.is_active'] ? (
                        <span style={{ color: 'green' }}>{t("Active")}</span>
                      ) : (
                        <span style={{ color: 'red' }}>In-Active</span>
                      )}
                    </span>
                  )}
                {state?.userInfo?.loyalty_organization_name !== 'Henry Schein Dental' && <br />}
                {access['sidebar']['changeLoyalty'][state.userInfo.role] &&
                  state?.ALA?.['Loyalty_Account.deactive_date'] && (
                    <span>
                      {t('Deactive Date')}:{' '}
                      {moment(
                        state?.ALA?.['Loyalty_Account.deactive_date']
                      ).format('MMM-YYYY')}
                    </span>
                  )}
              </div>
              {
                state?.ACA?.privilege_code === 'ST0' && state?.ACA?.signature_flag === true  ? (
                  <span style={{ fontWeight: "normal" }}>Monthly Subscriber</span>
                ) : state?.ACA?.privilege_code === 'ST1'&& state?.ACA?.signature_flag === true ? (
                  <span style={{ fontWeight: "normal" }}>Annual Subscriber</span>
                ) :state?.ACA?.privilege_code === 'ST2' && state?.ACA?.signature_flag === true ? (
                  <span style={{ fontWeight: "normal" }}>Trial Subscriber</span>
                ) : null
              }

              {state?.userInfo?.isCdrAdmin && (
                <div
                  onClick={() => history.push('/dashboard/loyalty')}
                  className={state?.ACA?.unlocked_flag ? classes.changeLoyaltyBtnUnlock:classes.changeLoyaltyBtn}
                >
                  {t('Change Account')}
                </div>
                
              )}

              

            </div>
          </div>
        </div>
        <List>
          {/* {routes1 &&
            routes1.map((route, i) => (
              <Fragment key={t(route.name)}>
                {route.to === "/dashboard/redeem" ? (
                  (state?.ALA?.["Loyalty_Account.is_active"]
                  // && 
                    // !(state?.userInfo?.role_id == null &&
                    //   (state?.ALA?.["Loyalty_Account.tier"] == "Bronze" && sessionStorage.getItem('redeemBtnDisabled') != null))
                      ) &&
                  (
                    <Link
                      key={i}
                      to={() => {
                        return redirectLink(route.to, route.isRedirect);
                      }}
                      className={classes.Link}
                      onClick={() => {
                        if (route.isRedirect) {
                         
                          i18n.language == "en" ? window.open(route.to) : window.open(route.to_fr);
                          return;
                        }
                        document.body.scrollTop = 0; // For Safari
                        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                      }}
                    >
                      <ListItem
                        button
                        style={
                          i === 0 ? { borderTop: '1px solid #e4e4e4' } : null
                        }
                        className={
                          isThisRoute(route)
                            ? classes.sidebarItemActive
                            : classes.listItem
                        }
                      >
                        <ListItemText className={classes.listItemTxt}>
                          <span className={classes.sideBarStyle}>
                            {t(route.name)}
                          </span>
                        </ListItemText>
                      </ListItem>
                    </Link>
                  )
                ) : route.to === "/dashboard/statements" ? 
                ((moment(state?.ALA?.["Loyalty_Account.created_at"]).format('YYYY') != moment().format('YYYY') 
                && ((!state?.ALA?.["Loyalty_Account.dormant_paused_date"]) || 
                (
                  // if dormant_paused_date exists -> check reactivation_date
                  moment(
                    state?.ALA?.["Loyalty_Account.reactivation_date"] 
                    ? state?.ALA?.["Loyalty_Account.reactivation_date"] 
                    : new Date() // fallback: current date
                  ).format("YYYY") != moment().format("YYYY")
                )
                )&& (state?.pointsBalance?.pointsBalance >= 0||pointsAlter?.pointsBalance >= 0 )) &&
                
                  <Link
                    key={i}
                    to={() => {
                      return redirectLink(route.to, route.isRedirect);
                    }}
                    className={classes.Link}
                    onClick={() => {
                      if (route.isRedirect) {
                        
                        i18n.language == "en" ? window.open(route.to) : window.open(route.to_fr);
                        return;
                      }
                      document.body.scrollTop = 0; // For Safari
                      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                    }}
                  >
                    <ListItem
                      button
                      style={
                        i === 0 ? { borderTop: '1px solid #e4e4e4' } : null
                      }
                      className={
                        isThisRoute(route)
                          ? classes.sidebarItemActive
                          : classes.listItem
                      }
                    >
                      <ListItemText className={classes.listItemTxt}>
                        <span className={classes.sideBarStyle}>
                          {t(route.name)}
                        </span>
                      </ListItemText>
                    </ListItem>
                  </Link>) : (
                  <Link
                  key={i}
                   to={route.isRedirect ? "#" : redirectLink(route.to, route.isRedirect)}
                  className={classes.Link}
                  onClick={() => {
                    if (route.isRedirect) {
                      const org = state?.userInfo?.loyalty_organization_name;
                      const lang = i18n.language;
                  
                      let linkKey = route.linkName;
                  
                      if (org === 'Henry Schein Canada') {
                        linkKey += lang === 'fr' ? '_FR' : '_EN';
                      }
                    console.log(state.redirectionLinks?.[linkKey],"value link")
                      const redirectUrl = state.redirectionLinks?.[linkKey];
                      
                      if (redirectUrl) {
                        console.log("Opening URL:", redirectUrl);
                      
                        // ✅ fire analytics before redirect
                        logEvent({
                          event_type: "link_redierect",
                          event_name: route?.linkName,
                          page_url: redirectUrl,
                          link_name: route?.linkName || null,  // make sure you pass the linkName from your sidebar route
                          user_id: state?.userInfo?.user_id,
                          session_id: state?.userInfo?.session_id,
                        });
                        trackWithGTM({
                          database: state?.userInfo?.loyalty_organization_name,
                          event: "link_click",
                          pathname:redirectUrl,
                          userId: state?.userInfo?.user_id,
                          role_id:state?.userInfo?.role_id,
                          allstate:state
                        });
                      
                        setTimeout(() => {
                          window.open(redirectUrl, '_blank');
                        }, 200);
                      
                        document.body.scrollTop = 0; // Safari
                        document.documentElement.scrollTop = 0; // Chrome, Firefox, etc.
                      }
                      
                    }
                  }}
                     
                >
                
                
                    <ListItem
                      button
                      style={
                        i === 0 ? { borderTop: '1px solid #e4e4e4' } : null
                      }
                      className={
                        isThisRoute(route)
                          ? classes.sidebarItemActive
                          : classes.listItem
                      }
                    >
                      <ListItemText className={classes.listItemTxt}>
                        <span className={classes.sideBarStyle}>
                          {t(route.name)}
                        </span>
                      </ListItemText>
                    </ListItem>
                  </Link>
                )}
              </Fragment>
            ))} */}

            {routes1 &&
  routes1.map((route, i) => (
    <Fragment key={t(route.name)}>
      {route.to === "/dashboard/redeem" ? (
        (
          state?.ALA?.["Loyalty_Account.is_active"] &&
          !(
            state?.userInfo?.loyalty_organization_name ===
              "Henry Schein Dental" &&
            Number(state?.pointsBalance?.pointsBalance) === 0
          )
        ) && (
          <Link
            key={i}
            to={() => {
              return redirectLink(route.to, route.isRedirect);
            }}
            className={classes.Link}
            onClick={() => {
              if (route.isRedirect) {
                i18n.language === "en"
                  ? window.open(route.to)
                  : window.open(route.to_fr);
                return;
              }

              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
            }}
          >
            <ListItem
              button
              style={
                i === 0
                  ? { borderTop: "1px solid #e4e4e4" }
                  : null
              }
              className={
                isThisRoute(route)
                  ? classes.sidebarItemActive
                  : classes.listItem
              }
            >
              <ListItemText className={classes.listItemTxt}>
                <span className={classes.sideBarStyle}>
                  {t(route.name)}
                </span>
              </ListItemText>
            </ListItem>
          </Link>
        )
      ) : route.to === "/dashboard/statements" ? (
        (
          moment(
            state?.ALA?.["Loyalty_Account.created_at"]
          ).format("YYYY") !== moment().format("YYYY") &&
          (
            !state?.ALA?.["Loyalty_Account.dormant_paused_date"] ||
            moment(
              state?.ALA?.["Loyalty_Account.reactivation_date"]
                ? state?.ALA?.["Loyalty_Account.reactivation_date"]
                : new Date()
            ).format("YYYY") !== moment().format("YYYY")
          ) &&
          (
            state?.pointsBalance?.pointsBalance >= 0 ||
            pointsAlter?.pointsBalance >= 0
          )
        ) && (
          <Link
            key={i}
            to={() => {
              return redirectLink(route.to, route.isRedirect);
            }}
            className={classes.Link}
            onClick={() => {
              if (route.isRedirect) {
                i18n.language === "en"
                  ? window.open(route.to)
                  : window.open(route.to_fr);
                return;
              }

              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
            }}
          >
            <ListItem
              button
              style={
                i === 0
                  ? { borderTop: "1px solid #e4e4e4" }
                  : null
              }
              className={
                isThisRoute(route)
                  ? classes.sidebarItemActive
                  : classes.listItem
              }
            >
              <ListItemText className={classes.listItemTxt}>
                <span className={classes.sideBarStyle}>
                  {t(route.name)}
                </span>
              </ListItemText>
            </ListItem>
          </Link>
        )
      ) : (
        <Link
          key={i}
          to={
            route.isRedirect
              ? "#"
              : redirectLink(route.to, route.isRedirect)
          }
          className={classes.Link}
          onClick={() => {
            if (route.isRedirect) {
              const org =
                state?.userInfo?.loyalty_organization_name;

              const lang = i18n.language;

              let linkKey = route.linkName;

              if (org === "Henry Schein Canada") {
                linkKey += lang === "fr" ? "_FR" : "_EN";
              }

              console.log(
                state.redirectionLinks?.[linkKey],
                "value link"
              );

              const redirectUrl =
                state.redirectionLinks?.[linkKey];

              if (redirectUrl) {
                console.log("Opening URL:", redirectUrl);

                // Analytics
                logEvent({
                  event_type: "link_redierect",
                  event_name: route?.linkName,
                  page_url: redirectUrl,
                  link_name: route?.linkName || null,
                  user_id: state?.userInfo?.user_id,
                  session_id: state?.userInfo?.session_id,
                });

                trackWithGTM({
                  database:
                    state?.userInfo?.loyalty_organization_name,
                  event: "link_click",
                  pathname: redirectUrl,
                  userId: state?.userInfo?.user_id,
                  role_id: state?.userInfo?.role_id,
                  allstate: state,
                });

                setTimeout(() => {
                  window.open(redirectUrl, "_blank");
                }, 200);

                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
              }
            }
          }}
        >
          <ListItem
            button
            style={
              i === 0
                ? { borderTop: "1px solid #e4e4e4" }
                : null
            }
            className={
              isThisRoute(route)
                ? classes.sidebarItemActive
                : classes.listItem
            }
          >
            <ListItemText className={classes.listItemTxt}>
              <span className={classes.sideBarStyle}>
                {t(route.name)}
              </span>
            </ListItemText>
          </ListItem>
        </Link>
      )}
    </Fragment>
  ))}
          {routes2.length ? (
            <div
              key={'admin-sideBar'}
              className={classes.Link}
              onClick={toggleAdminOption}
            >
              <ListItem
                button
                className={
                  isThisRoute() ? classes.sidebarItemActive : classes.listItem
                }
              >
                <ListItemText className={classes.listItemTxt}>
                  <span className={classes.sideBarStyle}>{t('Admin')}</span>
                </ListItemText>
                {isAdminOption ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              </ListItem>
            </div>
          ) : null}
          {isAdminOption &&
            routes2 &&
            routes2.map((route, i) => (
              <Link
                key={t(route.name)}
                to={() => {
                  return redirectLink(route.to, route.isRedirect);
                }}
                className={classes.Link}
                onClick={() => {
                  if (route.isRedirect) {
                    window.open(route.to);
                    return;
                  }
                  document.body.scrollTop = 0; // For Safari
                  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                }}
              >
                <ListItem
                  button
                  className={
                    isThisRoute(route)
                      ? classes.sidebarItemActive
                      : classes.listItem
                  }
                >
                  <ListItemText className={classes.listItemTxt}>
                    <span className={classes.sideBarStyle}>
                      {t(route.name)}
                    </span>
                  </ListItemText>
                </ListItem>
              </Link>
            ))}
            
            {state?.userInfo?.role_id == 10 ? (
  <>
            {routes3.length ? (
            <div
              key={'admin-sideBar'}
            
              className={classes.Link}
              onClick={toggleAdminOptionIT}
            >
              <ListItem
                button
                className={
                  isThisRoute() ? classes.sidebarItemActive : classes.listItem
                }
              >
                <ListItemText className={classes.listItemTxt}>
                  <span className={classes.sideBarStyle}>{t('IT Admin')}</span>
                </ListItemText>
                {isITAdminOption ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              </ListItem>
            </div>
          ) : null}
          {isITAdminOption &&
            routes3 &&
            routes3.map((route, i) => (
              <Link
                key={t(route.name)}
                to={() => {
                  return redirectLink(route.to, route.isRedirect);
                }}
                className={classes.Link}
                onClick={() => {
                  if (route.isRedirect) {
                    window.open(route.to);
                    return;
                  }
                  document.body.scrollTop = 0; // For Safari
                  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                }}
              >
                <ListItem
                  button
                  className={
                    isThisRoute(route)
                      ? classes.sidebarItemActive
                      : classes.listItem
                  }
                >
                  <ListItemText className={classes.listItemTxt}>
                    <span className={classes.sideBarStyle}>
                      {t(route.name)}
                    </span>
                  </ListItemText>
                </ListItem>
              </Link>
            ))}
                   </>
                ) : null}
            </List>
       

        <Dialog
          onClose={() => {
            setDialog(false);
          }}
          aria-labelledby='simple-dialog-title'
          open={dialog}
        >
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button>No</Button>
            </Grid>
            <Grid item xs={6}>
              <Button>Yes</Button>
            </Grid>
          </Grid>
        </Dialog>
      </div>
    </React.Fragment>
  );
}
